
export const setHeadersForFetch = () => {
  const authTokenObj = JSON.parse(sessionStorage.getItem('sessionToken'));
  let headers = {'Content-Type': 'application/json',
      'Authorization': JSON.stringify(authTokenObj.token),
  };
                
  return headers;
   
}





